import i18n from 'utils/flight/i18n';
import { addDays } from 'utils/utils';
import { dateFormat } from 'utils/shared/utils';

export class SearchFlightModel {
  departureDesc: string;
  departureCode: string;
  arrivalDesc: string;
  arrivalCode: string;
  departureDate: string;
  arrivalDate: string;
  numberOfAdults: number;
  numberOfChildren: number;
  numberOfYouths: number;
  numberOfSeniors: number;
  numberOfInfants: number;
  cabineType: number;
  searchType: string;
  fromValue: string;
  toValue: string;
  directFlight: boolean;
  recaptchaToken?: string;
  additionalFrom?: string;
  additionalTo?: string;
  additionalFromLabel?: string;
  additionalToLabel?: string;
  skipHistorySave?: boolean;
  numberOfBags: number;

  flightSourcesDefault: string;
  isGds: boolean;
  isNDC: boolean;
  isLowCost: boolean;
  constructor(
    params?: URLSearchParams,
    destination?: { arrivalCode: string; arrivalDesc: string },
  ) {
    if (params) {
      const paramsObj = Object.fromEntries(params.entries());
      this.departureDesc = paramsObj.departureDesc;
      this.departureCode = paramsObj.departureCode;
      this.arrivalDesc = paramsObj.arrivalDesc;
      this.arrivalCode = paramsObj.arrivalCode;
      this.departureDate = paramsObj.departureDate;
      this.arrivalDate = paramsObj.arrivalDate;
      this.numberOfAdults = parseInt(paramsObj.numberOfAdults);
      this.numberOfChildren = parseInt(paramsObj.numberOfChildren);
      this.numberOfYouths = parseInt(paramsObj.numberOfYouths);
      this.numberOfSeniors = parseInt(paramsObj.numberOfSeniors);
      this.numberOfInfants = parseInt(paramsObj.numberOfInfants);
      this.cabineType = parseInt(paramsObj.cabineType);
      this.searchType = paramsObj.searchType;
      this.directFlight = paramsObj.directFlight === 'true';
      this.additionalFrom = paramsObj.additionalFrom;
      this.additionalTo = paramsObj.additionalTo;
      this.additionalFromLabel = paramsObj.additionalFromLabel;
      this.additionalToLabel = paramsObj.additionalToLabel;
      this.numberOfBags = parseInt(paramsObj.numberOfBags) || 0;
      this.isGds = paramsObj.isGds === 'true';
      this.isNDC = paramsObj.isNDC === 'true';
      this.isLowCost = paramsObj.isLowCost === 'true';
      this.flightSourcesDefault = paramsObj.flightSourcesDefault;
    } else {
      const initSiteData = localStorage.getItem('initSiteData');
      const initSiteDataObj = initSiteData ? JSON.parse(initSiteData) : {};
      this.departureDesc = i18n.t('tlv') ?? 'TLV - Tel Aviv';
      this.departureCode = 'TLV';
      this.arrivalDesc = destination?.arrivalDesc || '';
      this.arrivalCode = destination?.arrivalCode || '';
      this.departureDate = dateFormat(addDays(14), 'yyyy-MM-dd', 'en');
      this.arrivalDate = dateFormat(addDays(21), 'yyyy-MM-dd', 'en');
      this.numberOfAdults = 1;
      this.numberOfChildren = 0;
      this.numberOfYouths = 0;
      this.numberOfSeniors = 0;
      this.numberOfInfants = 0;
      this.cabineType = 0;
      this.searchType = '1';
      this.numberOfBags = initSiteDataObj.other?.baggageSearchDefault === 'true' ? 1 : 0;
      this.directFlight = initSiteDataObj.other?.directFlightsDefault === 'true';
      this.isGds = true;
      this.isNDC = false;
      this.isLowCost = false;
      this.flightSourcesDefault = '';
    }
    this.fromValue = '';
    this.toValue = '';
  }
}
